// extracted by mini-css-extract-plugin
module.exports = {"arrow":"Arrow_arrow__KOljX","flip":"Arrow_flip__4LcD5","trapezoid":"Arrow_trapezoid__Xb31N"};